import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Icon } from 'components/Icon';

import './style.scss';

const status = {
  viewed: 'Просмотрено',
  create: 'Создано',
  update: 'Изменено',
};

const HistoryPopup = ({ style, data, onOutside }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside (event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onOutside();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef, onOutside]);

  if (!data) {
    return <></>;
  }

  return (
    <div ref={wrapperRef} style={style} className="main-button-modal">
      {data.reverse().map((act, i) => {
        const date = new Date(act.date).getTime();

        return (
          <div key={act.id} className="history-props">
            <div className="history-prop">
              {status[act.action]}: <b>{act.worker.fio_short}</b>
            </div>

            <div className="history-prop">
              Время:
              <b>{moment(date).format('HH:mm DD.MM')}</b>
            </div>

            {i !== data.length - 1 && (
              <div className="history-prop centered">
                <Icon name="arrow-down" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

HistoryPopup.propTypes = {
  data: PropTypes.array,
  onOutside: PropTypes.func,
  style: PropTypes.object,
};

HistoryPopup.defaultProps = {
  data: null,
  style: {},
  onOutside: () => {},
};

export { HistoryPopup };
